<template>
  <div class="row d-flex justify-content-center align-items-center" style="margin-top:5%">
    <div class="container" v-show="loading"> <h3> Videonuz Yükleniyor Lütfen Bekleyin </h3></div>
    <div v-show="!loading && !embedcode" class="col-xs-12 col-md-8">
      <b-button variant="success" @click="goBack">Geri</b-button>
      <h5 class="text-center">{{videoadi}}</h5>
      <video playsinline ref="fplayer" id="fplayer" class="video-js vjs-default-skin col-xs-10"  height="450px"></video>
      <!--<div  ref="fplayer">-->
     <!---->
      <!--</div>-->
    </div>
    <div v-show="embedcode" class="col-xs-12 col-md-8 ">
        <div class="row" style="margin-bottom: 20px"><b-button variant="success" :to="{name: 'Sinavlarim'}">Geri</b-button></div>
        <div class="embed-responsive embed-responsive-16by9">
          <div v-html="embedcode"></div>
        </div>
    </div>
  </div>
</template>
<script>
// import { numberToAnswer } from '../utility/statics'
import {mapState} from 'vuex'
// import _ from 'lodash'
import axios from 'axios'
export default {
  name: 'VideoGoster',
  computed: mapState([
    'user'
  ]),
  data: () => {
    return {
      loading: true,
      url: '',
      token: null,
      videoadi: '',
      embedcode: null
    }
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/Sinavlarim')
    }
  },
  async mounted () {
    this.url = this.$route.params.url
    this.videoadi = this.$route.params.videoadi
    this.embedcode = this.$route.params.embedcode
    console.log(this.embedcode)
    axios
      .post(this.$serviceAddress + 'api/v5/getVideoToken', {
        token: this.user.token
      })
      .then((response) => {
        if (response.data.result.isOK === true) {
          this.token = response.data.result.token
          const videoJsOptions = {
            playsinline: true,
            aspectRatio: '16:9',
            fluid: true,
            autoplay: false,
            controls: true,
            preload: 'auto',
            playbackRates: [0.5, 1, 1.5, 2, 2.5],
            poster: 'https://www.ankaradil.com/img/logo1200px.jpg',
            sources: [
              // {
              //   src: 'https://vod.ankaradil.com/eydsorg/smil:' + this.url + '.smil/manifest.mpd?token=' + this.token,
              //   type: 'application/dash+xml'
              // },
              {
                src: 'https://vod.ankaradil.com/eydsorg/smil:' + this.url + '.smil/playlist.m3u8?token=' + this.token,
                type: 'application/x-mpegurl'}
            ]
          }
          this.$videojs(this.$refs.fplayer, videoJsOptions)
          this.loading = false
        } else {
          console.log('error :' + response.data.err)
        }
      }).catch(e => console.log(e))
  }
}
</script>

<style scoped>
  .secenek {
    padding-right: 10px;
  }
  .dogruSecenek {
    color:green;
  }
  .yanlisSecenek {
    color: darkred;
  }
  .cevap {
    color: greenyellow;
  }
  .mor {
    color: #453f92;
  }
</style>



// WEBPACK FOOTER //
// src/components/VideoGosterVideoJS.vue